<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>前台设置</a-breadcrumb-item>
    <a-breadcrumb-item>前台配置</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :loading="isLoading"
    :pagination="false"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
        <!-- 编辑 -->
        <a @click="handleKeywordEdit(record)" v-if="record.id === 1">编辑</a>
      </template>
    </template>
  </a-table>
  <!-- 关键词编辑 -->
  <KeywordEdit ref="RefKeywordEdit" @success="getList"></KeywordEdit>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue'
import KeywordEdit from './components-configs/KeywordEdit.vue'
import { frontdeskList } from '@/api/request'

// 关键字编辑组件实例
let RefKeywordEdit = ref(null)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '配置项',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数
onBeforeMount(() => {
  // 获取配置列表
  getList()
})

// 获取配置列表
function getList () {
  isLoading.value = true
  frontdeskList().then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.result
    } else {
      message.error(res.message || msg)
    }
  })
}

// 关键词编辑
function handleKeywordEdit (record) {
  RefKeywordEdit.value.showDrawer(record)
}

</script>

<style scoped>
.table-view {
  margin-top: 30px;
}
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}
.tool-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 20px;
}
</style>